/* eslint-disable react/prop-types */
import { Chip } from "@mui/material";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import { truncateString, ActionsCellRenderer } from "utils/helpers";
import DeleteIcon from "assets/images/icons/deleteIcon.svg";
import EditIcon from "assets/images/icons/editIcon.svg";
import { visibilityOptions } from "../../../../constants";
import StatusChip from "components/common/StatusChip";

export const makeColumns = (handleAction, handleUpdateStatus) => {
  const columns = [
    {
      Header: "Category",
      accessor: "category",
      width: "25%",
      Cell: ({ value }) => (
        <MDBox>
          <MDTypography sx={{ fontSize: "14px", fontWeight: "400" }}>
            {truncateString(value, 25)}
          </MDTypography>
        </MDBox>
      ),
    },
    {
      Header: "Type",
      accessor: "type",
      width: "25%",
      Cell: ({ value }) => (
        <Chip
          label={value}
          sx={{
            color: "#000",
            minWidth: "140px",
            backgroundColor: "#EBEBEB",
          }}
        />
      ),
    },
    {
      Header: "Traffic",
      accessor: "traffic",
      width: "25%",
      Cell: ({ value }) => (
        <MDBox>
          <MDTypography sx={{ fontSize: "14px", fontWeight: "500" }}>
            {value ? value : "-"}
          </MDTypography>
        </MDBox>
      ),
    },
    {
      Header: "Publications",
      accessor: "publicationInfo",
      width: "15%",
      Cell: ({ value }) => (
        <MDBox>
          <MDTypography sx={{ fontSize: "14px", fontWeight: "500" }}>{value?.length}</MDTypography>
        </MDBox>
      ),
    },
    {
      Header: "Visibility",
      width: "12%",
      accessor: "visibility",
      Cell: ({ value, row }) => (
        <StatusChip
          value={value}
          options={visibilityOptions}
          excludeFromMenu={["PRIVATE"]}
          onChange={(val) => handleUpdateStatus(row, val)}
        />
      ),
    },
    {
      Header: "Credits",
      accessor: "price",
      width: "10%",
      Cell: ({ value }) => (
        <MDBox>
          <MDTypography sx={{ fontSize: "14px", fontWeight: "400" }}>
            <strong>{value}</strong>
          </MDTypography>
        </MDBox>
      ),
    },
    {
      Header: "Action",
      align: "right",
      width: "15%",
      Cell: ({ row }) => (
        <ActionsCellRenderer
          actions={[
            { imgIcon: EditIcon, onClick: () => handleAction(row.original.id, "edit") },
            { imgIcon: DeleteIcon, onClick: () => handleAction(row.original.id, "delete") },
          ]}
        />
      ),
    },
  ];

  return columns;
};
